export default "assets/switch_1.png"